import {FC, PropsWithChildren} from 'react';

import {TrackingProps} from '@/components/tracked-atoms/types';
import Button from '../button';

type Props = PropsWithChildren<{
  ['data-testid']?: string;
  title: string;
  action?: {
    label: string;
    trackingKey: TrackingProps['trackingKey'];
    onClick: () => void;
  };
}>;

export const ErrorPresenter: FC<Props> = ({'data-testid': dataTestId, action, title, children}) => {
  return (
    <div className="flex h-full flex-1 items-center justify-center" data-testid={dataTestId}>
      <div className="mx-8 mt-6 text-center">
        <h1 className="mb-6 text-3xl font-bold text-violet">{title}</h1>
        <div className="mb-8 text-base text-charcoal">{children}</div>

        {action && (
          <div className="flex justify-center">
            <Button label={action.label} onClick={action.onClick} trackingKey={action.trackingKey} />
          </div>
        )}
      </div>
    </div>
  );
};
